import { render, staticRenderFns } from "./field.vue?vue&type=template&id=e3fbfb18"
import script from "./field.vue?vue&type=script&lang=js"
export * from "./field.vue?vue&type=script&lang=js"
import style0 from "./field.vue?vue&type=style&index=0&id=e3fbfb18&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3fbfb18')) {
      api.createRecord('e3fbfb18', component.options)
    } else {
      api.reload('e3fbfb18', component.options)
    }
    module.hot.accept("./field.vue?vue&type=template&id=e3fbfb18", function () {
      api.rerender('e3fbfb18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/field.vue"
export default component.exports